import { CSSProperties } from "react";

import { homeDark, homeLight, homeShared, HomeTokenSet } from "@layout/theme/homeTokens";

/**
 * The home screen reads every color through CSS custom properties so the
 * whole surface re-themes when the user flips light/dark on the profile
 * page. Token values live in layout/theme/homeTokens.ts (the dark set is
 * literal from design/futuremoney-home-spec.html); this file just maps
 * them onto `var(--hm-*)` references plus the theme-independent constants.
 */

const varRef = Object.fromEntries(
  Object.keys(homeDark).map((key) => [key, `var(--hm-${key})`]),
) as Record<keyof HomeTokenSet, string>;

export const home = {
  ...varRef,
  serif: homeShared.serif,
  sans: homeShared.sans,
  radius: homeShared.radius,
  pagePad: homeShared.pagePad,
};

/** Inline-style object declaring the variables for one theme. */
export const homeCssVars = (dark: boolean): CSSProperties => {
  const tokens = dark ? homeDark : homeLight;

  return Object.fromEntries(
    Object.entries(tokens).map(([key, value]) => [`--hm-${key}`, value]),
  ) as CSSProperties;
};

/** SVG fractal-noise grain used by the ground and the do-more cards. */
export const GRAIN_URL = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)'/%3E%3C/svg%3E")`;
